import * as yup from "yup";
import { CONSTANT } from "../shared/constants/constant-data";

export const loginValidationSchema = yup.object().shape({
  email: yup
    .string()
    .required(CONSTANT.AUTHENTICATION.AUTH_ORG_EMAIL_REQUIRED)
    .email(CONSTANT.AUTHENTICATION.AUTH_ORG_EMAIL_VAILD)
    .matches(
      CONSTANT.AUTHENTICATION.AUTH_EMAIL_PATTERN,
      CONSTANT.AUTHENTICATION.AUTH_ORG_EMAIL_VAILD
    )
    .max(64, CONSTANT.AUTHENTICATION.AUTH_ORG_EMAIL_MAX_LENGTH),

  password: yup
    .string()
    .required(CONSTANT.AUTHENTICATION.LOG_IN_PASSWORD_REQUIRED)
    .min(12, CONSTANT.AUTHENTICATION.AUTH_PASSWORD_MIN_LENGTH)
    .max(20, CONSTANT.AUTHENTICATION.AUTH_PASSWORD_MAX_LENGTH)
    .matches(/^\S*$/, CONSTANT.AUTHENTICATION.AUTH_PASSWORD_NO_SPACE),

  recaptcha: yup.string(),
  offlineCaptcha: yup.string(),
});

export const resetPasswordValidationSchema = yup.object().shape({
  firstname: yup
    .string()
    .required(CONSTANT.AUTHENTICATION.AUTH_FIRST_NAME_MSG)
    .min(1, CONSTANT.AUTHENTICATION.AUTH_FIRST_NAME_MIN_LENGTH)
    .max(32, CONSTANT.AUTHENTICATION.AUTH_FIRST_NAME_MAX_LENGTH)
    .matches(
      /^[a-zA-Z]+( [a-zA-Z]+)*$/,
      CONSTANT.AUTHENTICATION.AUTH_FIRST_NAME_PATTERN
    ),

  lastname: yup
    .string()
    .required(CONSTANT.AUTHENTICATION.AUTH_LAST_NAME_MSG)
    .min(1, CONSTANT.AUTHENTICATION.AUTH_LAST_NAME_MIN_LENGTH)
    .max(32, CONSTANT.AUTHENTICATION.AUTH_LAST_NAME_MAX_LENGTH)
    .matches(
      /^[a-zA-Z]+( [a-zA-Z]+)*$/,
      CONSTANT.AUTHENTICATION.AUTH_LAST_NAME_PATTERN
    ),



  password: yup
    .string()
    .required(CONSTANT.AUTHENTICATION.SIGN_IN_PASSWORD_REQUIRED)
    .min(12, CONSTANT.AUTHENTICATION.AUTH_PASSWORD_MIN_LENGTH)
    .max(20, CONSTANT.AUTHENTICATION.AUTH_PASSWORD_MAX_LENGTH)
    .matches(/^\S*$/, CONSTANT.AUTHENTICATION.AUTH_PASSWORD_NO_SPACE)
.matches(
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^_\-+=(){}\[\].,:~`|\\;"'<>/])[A-Za-z\d@$!%*?&#^_\-+=(){}\[\].,:~`|\\;"'<>/]{12,20}$/,
  CONSTANT.AUTHENTICATION.AUTH_PASSWORD_FORMAT
),


  confirmpassword: yup
    .string()
    .required(CONSTANT.AUTHENTICATION.CONFIRM_PASSWORD_REQUIRED)
    .min(12, CONSTANT.AUTHENTICATION.AUTH_PASSWORD_MIN_LENGTH)
    .max(20, CONSTANT.AUTHENTICATION.AUTH_PASSWORD_MAX_LENGTH)
    .matches(/^\S*$/, CONSTANT.AUTHENTICATION.AUTH_PASSWORD_NO_SPACE)
.matches(
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^_\-+=(){}\[\].,:~`|\\;"'<>/])[A-Za-z\d@$!%*?&#^_\-+=(){}\[\].,:~`|\\;"'<>/]{12,20}$/,
  CONSTANT.AUTHENTICATION.AUTH_PASSWORD_FORMAT
),
});
